import { render, staticRenderFns } from "./AbaComponent.vue?vue&type=template&id=f36fbf00"
import script from "./AbaComponent.vue?vue&type=script&lang=js"
export * from "./AbaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports